import React from 'react'
import { useTranslation } from 'react-i18next'

import { Tenant as TenantType } from '../..'
import Tenant from '../tenant/tenant'

interface Props {
    tenants: TenantType[]
    onSubmit: (tenantId: string) => void
}

export default function Tenants(props: Props) {
    const { tenants, onSubmit } = props

    const { t } = useTranslation()

    return (
        <>
            <div className="mb-4 text-lg">{t('Select a tenant')}</div>
            <div data-testid="tenants-list" className="w-full space-y-4 overflow-auto px-4">
                {tenants.map((tenant) => (
                    <Tenant key={`tenant-${tenant.id}`} tenant={tenant} onSubmit={onSubmit} />
                ))}
            </div>
        </>
    )
}
